export const items = [
  {},
  {
    id: "station",
    label: "Station",
  },
  {
    id: "material",
    label: "Material",
  },
  {
    id: "completed",
    label: "Completed",
  },
  {
    id: "scrapped",
    label: "Scrapped",
  },
  {
    id: "plannedStartDate",
    label: "Planned Start Date",
  },
  {
    id: "plannedEndDate",
    label: "Planned End Date",
  },
  {
    id: "startDate",
    label: "Start Date",
  },
  {
    id: "endDate",
    label: "End Date",
  },
];
export const keys = [
  {
    value: "station.label",
  },
  {
    value: "material.name",
  },
  {
    value: "completed",
    defaultValue: 0,
  },
  {
    value: "scrapped",
    defaultValue: 0,
  },
  {
    value: "plannedStartDate",
    isDate: true,
  },
  {
    value: "plannedEndDate",
    isDate: true,
  },
  {
    value: "startDate",
    isDate: true,
  },
  {
    value: "endDate",
    isDate: true,
  },
];
